<template>
  <div class="communication-container">
     <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">SRM List</v-toolbar-title>
      </v-col>
    </v-row>

    <v-row class="custom-form-control">
      <v-col cols="12">
        <v-row>
          <v-col class="comm-header-col data-query-section pb-0" cols="12" lg="5">
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_SNDR"
                  placeholder="Find by Sender"
                  hide-details
                  dense
                  solo
                  v-on:keyup.enter="queryList"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_RCVR"
                  placeholder="Find by Receiver"
                  hide-details
                  dense
                  solo
                  v-on:keyup.enter="queryList"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_ID"
                  placeholder="Find by Message"
                  hide-details
                  dense
                  solo
                  v-on:keyup.enter="queryList"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  placeholder="Status"
                  class="custom-selectbox"
                  hide-details
                  dense
                  solo
                  v-model="masterSearchItems.data[0].PRCS_STS"
                  :items="srmStatusSearchArr"
                  :menu-props="{offsetY: true,}"
                  @change="queryList"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="comm-header-col date-query-section pb-0" cols="12" lg="7">
            <v-row>
              <v-col cols="12" md="3" class="pt-0">
              </v-col>
              <v-col cols="12" md="7" class="pt-0">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      placeholder="Date Type"
                      class="custom-selectbox"
                      v-model="masterSearchItems.init.DAT_TYPE"
                      :items="dateTypes"
                      hide-details
                      dense
                      solo
                      :menu-props="{offsetY: true,}"
                    ></v-autocomplete>
                  </v-col>
              <v-col cols="12" md="4">
                <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    placeholder="From Date (YYYYMMDD)"
                    class="from-date-picker"
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker class="date-period-picker" v-model="masterSearchItems.init.FR_DAT" @change="changeFromDate" @input="fromdate_menu = false" :max="getMaxDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    class="to-date-picker"
                    :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                    placeholder="To Date (YYYYMMDD)"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker class="date-period-picker" v-model="masterSearchItems.init.TO_DAT" @change="changeToDate" @input="todate_menu = false" :min="getMinDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              </v-col>
                </v-row>

              </v-col>
              <v-col class="comm-header-col pb-0 action-section pt-0" cols="12" md="2">
                <div class="button-group-div">
                    <v-btn class="search-data-analysis-button btn-height-custom" color="primary" @click.native="queryList">
                      <v-icon x-small class="mr-2">fa fa-search</v-icon>Search
                    </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="comm-header-col pb-0 pt-4 pr-4" cols="12" lg="9">
        <v-row>
          <v-col class="pb-0 pt-0 pr-0" cols="12" md="12">
            <div class="btn-form-control">
              <v-btn class="btn-top-table btn-height-custom" color="#353f61" @click="addRowSRMList">
                <v-icon x-small class="mr-2">fas fa-plus</v-icon>Add
              </v-btn>
              <v-btn class="btn-top-table btn-height-custom" color="#353f61" @click="saveItems">
                <v-icon x-small class="mr-2">fas fa-save</v-icon>Save
              </v-btn>
              <v-btn class="btn-top-table btn-height-custom" color="#CD5F5F" @click="copyToRepository">
                <v-icon x-small class="mr-2">fas fa-trash-alt</v-icon>copyToReapository
              </v-btn>
              <v-btn class="btn-top-table btn-height-custom" color="#CD5F5F" @click="saveRepository">
                <v-icon x-small class="mr-2">fas fa-trash-alt</v-icon>saveReapository
              </v-btn>
              <v-btn class="btn-top-table btn-height-custom" @click="generateExcelFile" color="#217346">
                <v-icon x-small class="mr-2">fas fa-file-excel</v-icon>Excel
              </v-btn>
              <div class="srm-total-status-section">
                <span class="srm-total-status-text">Total : </span>
                <span class="srm-total-status">{{mainGrid.length}}</span>
              </div>
              <div v-for="status in statusStatArr" @click="selectStatus(status)" class="srm-status-stat" :key="status.name">
                <span v-if="status.count != 0">
                  <span :class="[status.class, 'srm-status-name']">{{status.name}}</span>
                  <span class="srm-status-count">{{status.count}}</span>
                </span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col class="pb-0 pt-4" cols="12" lg="6">
        <v-row class="status-stat-section">
          <v-col class="pt-0 pb-0 pl-0 pr-0" lg="2">
            <span class="srm-total-status-section">
              <span class="srm-total-status-text">Total : </span>
              <span class="srm-total-status">{{mainGrid.length}}</span>
            </span>
          </v-col>
          <v-col class="pt-0 pb-0 pl-0 pr-2" lg="10">
            <span v-for="status in statusStatArr" v-if="status.count != 0" @click="selectStatus(status)" class="srm-status-stat" :key="status.name">
              <span :class="[status.class, 'srm-status-name']">{{status.name}}</span>
              <span class="srm-status-count">{{status.count}}</span>
            </span>
          </v-col>
        </v-row>
      </v-col> -->
      <v-col class="pb-0 pt-4" cols="12" lg="3">
        <v-row>
          <v-col class="pb-0 pt-0" cols="12" md="6">
            <v-select
              v-model="searchBy"
              :items="searchByItems"
              class="data-table-select-box custom-selectbox search-selectbox"
              placeholder="Search Column"
              height="30"
              hide-details
              dense
              solo
            ></v-select>
          </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6">
              <v-text-field
                  v-model="search"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  append-icon="fa fa-search"
                  placeholder="Enter search text"
                  outlined
                  hide-details
                  dense
                  solo
                  @input="onFilterAnalysis"
                  @click:append="onFilterAnalysis"
                  v-on:keyup.enter="onFilterAnalysis"
              ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-table
          ref="srm_list_table"
          is-horizontal-resize
          width="100%"
          :height="680"
          :title-rows="titleRows"
          :columns="columns"
          :table-data="mainGrid"
          :row-class-name="setRowClassName"
          :row-dblclick="(index, item, col) => { item.SYSSTATUS = 'U'}"
          class="compare-merge-table srm-list-table"
          :errorContent="'No matching records found'"
          row-hover-color="#eee"
        >
          <template v-slot:custome=" { item } ">
            <v-icon v-if="item.SYSSTATUS == 'I'" x-small color="#CD5F5F" @click="deleteSRMRowItem(item)">fas fa-trash-alt</v-icon>
          </template>
          <template v-slot:SRM_SNDR=" { item } ">
            <v-text-field
                v-if="item.SYSSTATUS != ''"
                :ref="'sndr_row_' + item.ROWID"
                autofocus
                v-model="item.SRM_SNDR"
                class="data-table-filter-text-field search-button-data-analysis-table pt-1"
                heigth="30"
                placeholder="Enter the Sender"
                outlined
                hide-details
                dense
                solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">
              {{item.SRM_SNDR}}
            </span>
          </template>
          <template v-slot:SRM_RCVR=" { item } ">
            <v-text-field
                v-if="item.SYSSTATUS != ''"
                v-model="item.SRM_RCVR"
                class="data-table-filter-text-field search-button-data-analysis-table pt-1"
                heigth="30"
                placeholder="Enter the Receiver"
                outlined
                hide-details
                dense
                solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">
              {{item.SRM_RCVR}}
            </span>
          </template>
          <template v-slot:SRM_MSG_ID=" { item } ">
            <v-text-field
                v-if="item.SYSSTATUS != ''"
                v-model="item.SRM_MSG_ID"
                class="data-table-filter-text-field search-button-data-analysis-table pt-1"
                heigth="30"
                placeholder="Message"
                outlined
                hide-details
                dense
                solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">
              {{item.SRM_MSG_ID}}
            </span>
          </template>
          <template v-slot:SRM_PRCS_STS=" { item } ">
            <v-select
              :items="srmStatusArr"
              v-model="item.SRM_PRCS_STS"
              :class="[srmStatusClass(item), 'data-table-select-box', 'srm-select-box', 'custom-selectbox', 'communication-select-box', 'pt-1']"
              @change="item.SYSSTATUS == 'I' ? '' : item.SYSSTATUS='U'"
              placeholder="Select"
              height="30"
              hide-details
              dense
              solo
              outlined
            ></v-select>
          </template>
          <template v-slot:SRM_COMM_TP=" { item } ">
            <v-select
              :items="communicationArr"
              v-model="item.SRM_COMM_TP"
              class="data-table-select-box srm-select-box custom-selectbox communication-select-box pt-1"
              placeholder="Select"
              height="30"
              hide-details
              dense
              solo
              outlined
              @change="item.SYSSTATUS == 'I' ? '' : item.SYSSTATUS='U'"
            ></v-select>
          </template>
          <template v-slot:ATF_FILE_NAME=" { item } ">
            <a class="download-attach-file-text" @click="downloadAttachFile(item)">{{ item.ATF_FILE_CNT > 1 ? item.ATF_FILE_NAME + `(+${item.ATF_FILE_CNT - 1} ${item.ATF_FILE_CNT - 1 > 1 ? 'Files' : 'File'})` : item.ATF_FILE_NAME }}</a>
            <span @click="openAddReferenceFileDialog(item)"><v-icon x-small class="mr-2 ref-file-icon" color="#CD5F5F">far fa-arrow-alt-circle-up</v-icon></span>
          </template>
          <template v-slot:layout=" { item } ">
            <a v-if="item.LAY_MSG_ID != null && item.LAY_MSG_VER != null && item.LAY_PRCS_NO != null" @click="openLayoutView(item)">View</a>
          </template>
          <template v-slot:MAP_NAME=" { item } ">
            <a v-if="item.MAP_NAME == '' || item.MAP_NAME == null" @click="openMapListDialog(item)">Select</a>
            <a v-if="item.MAP_NAME != '' && item.MAP_NAME != null" @click="openMapListDialog(item)">{{ item.MAP_NAME }}</a>
          </template>
        </v-table>
      </v-col>
    </v-row>
    <!--
    <analyzedDialog ref="analyzedDialog">
    </analyzedDialog>
-->
<div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
    <analyzed-layout-dialog v-if="dialog.type == 'layoutView'" class="analyzed-layout-dialog"
      :params="params"
      :id="dialog.id" :ref='"dialog-" + dialog.id'
      :closeDialog="removeDialog" :dragEnd="dialogDragEnd"
      :dragStart="selectDialog" :move="dialogDragEnd"
      :options="dialog.options">
    </analyzed-layout-dialog>

    <upload-fileview-dialog v-if="dialog.type == 'fileUploadView'" class="analyzed-layout-dialog width-1000"
      :edifile="edifile"
      :bizfile="bizfile"
      :id="dialog.id" :ref='"dialog-" + dialog.id'
      :closeDialog="removeDialog" :dragEnd="dialogDragEnd"
      :dragStart="selectDialog" :move="dialogDragEnd"
      :options="dialog.options">
    </upload-fileview-dialog>

    <edi-upload-dialog
      v-if="dialog.type == 'ediUploadFile'"
      class="custom-dialog dialog-small"
      :id="dialog.id"
      :ref='"dialog-" + dialog.id'
      :closeDialog="removeDialog"
      :dragEnd="dialogDragEnd"
      :dragStart="selectDialog"
      :move="dialogDragEnd"
      :queryList="queryList"
      :options="dialog.options">
    </edi-upload-dialog>

    <merge-compare-dialog
      v-if="dialog.type == 'MergeCompare'"
      class="custom-dialog compare-merge-dialog"
      :params="params"
      :id="dialog.id"
      :ref='"dialog-" + dialog.id'
      :closeDialog="removeDialog"
      :dragEnd="dialogDragEnd"
      :dragStart="selectDialog"
      :move="dialogDragEnd"
      :options="dialog.options">
    </merge-compare-dialog>
    <map-list
      v-if="dialog.type == 'mapList'"
      class="maplist-layout-dialog"
      :id="dialog.id"
      :ref='"dialog-" + dialog.id'
      :closeDialog="removeDialog"
      :selectFile="loadMapList"
      :fileSelected= mapFile
      :dragEnd="dialogDragEnd"
      :dragStart="selectDialog"
      :move="dialogDragEnd"
      :queryList="mainGrid"
      :options="dialog.options"
      @inputSelectedMap="updatedMap($event)">
    </map-list>
    <addReferenceFile
      v-if="dialog.type == 'addReferenceFile'"
      class="addReferenceFile-layout-dialog"
      :id="dialog.id"
      ref="addReferenceFile"
      :closeDialog="removeDialog"
      :dragEnd="dialogDragEnd"
      :dragStart="selectDialog"
      :move="dialogDragEnd"
      :options="dialog.options"
      @openReferenceFilesList="openReferenceList($event)"
      @reloadPage="queryList">
    </addReferenceFile>
    <refenrenceFilesList
      v-if="dialog.type == 'refenrenceFilesList'"
      class="reference-files-list-layout-dialog"
      :id="dialog.id"
      :ref='"dialog-" + dialog.id'
      :closeDialog="removeDialog"
      :dragEnd="dialogDragEnd"
      :dragStart="selectDialog"
      :move="dialogDragEnd"
      :options="dialog.options"
      @inputSelectedFile="updatedReferenceFiles($event)">
    </refenrenceFilesList>

</div>
    <dialogWindow
      ref="mergeCompareInfoDialog"
      size="max"
      title="Merge & Compare"
      detail= 'Please select 2 to 4 items'
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      detail= 'Should be selected rows with the same message type'
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="addNewRowEmptyDialog"
      size="max"
      title="Add New"
      detail= 'Sender, Receiver, Message cannot be empty'
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="addNewRowDuplicateDialog"
      size="max"
      title="Add New"
      detail= 'Sender, Receiver, Message is already existed'
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      detail= 'Please check Date Period! Maximum period 6 Months'
      color="validation"
    >
    </dialogWindow>
  </div>
</template>

<script>
/* globals Store */
import ghIcon from '@/vue-dlb/assets/github.svg?raw'
import browserIcon from '@/vue-dlb/assets/browser.svg?raw'
import dialogIcon from '@/vue-dlb/assets/dialog.svg?raw'
import downloadIcon from '@/vue-dlb/assets/download.svg?raw'

import ediUploadDialog from '@/vue-dlb/views/commons/EdiFileUpload.vue'
//import analyzedDialog from '@/vue-dlb/views/analysis/AnalyzedDialog.vue'
import uploadFileviewDialog from '@/vue-dlb/views/commons/UploadFileView.vue'
import mergeCompareDialog from '@/vue-dlb/views/matching/MergeCompareDialog.vue'
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import mapList from '@/vue-dlb/views/srm/MapList.vue'
import addReferenceFile from '@/vue-dlb/views/srm/AddReferenceFile.vue'
import refenrenceFilesList from '@/vue-dlb/views/srm/ReferenceFilesList.vue'

import { debounce } from "lodash";
import { mapState } from "vuex";
import $ from "jquery";
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';

import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js";

export default {
  components: {
    ediUploadDialog,
    uploadFileviewDialog,
    mergeCompareDialog,
    mapList,
    addReferenceFile,
    refenrenceFilesList,
    dialogWindow
  },

  computed: {
    ...mapState("analysis", {
      masterItems: "masterItems",
      dataItems: "dataItems"
    }),    
        // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    ...mapState("common", {
        codeList: "codeList"
    }),
    ...mapState("srmlist", {
      mainGrid: "mainGrid",
      mainGridSource: "mainGridSource"
    }),
    ...mapState("repository", {
      mainGrid: "srmList",
      mainGridSource: "srmList"
    }),    
    quickSearch: {
      get: function () {
        return this.quickSearchFilter;
      },
      set: function ( val ) {
        this.quickSearchFilter = val;
        this.quickSearchFilter && this.quickSearchList();
      }
    },
    getMaxDate () {
      return this.masterSearchItems.init.TO_DAT;
    },
    getMinDate () {
      return this.masterSearchItems.init.FR_DAT;
    }
  },
  data: () => ({
    edifile: "",
    bizfile: "",
    parmas: "",
    fromDate: false,
    toDate: false,
    numberFormatter: new Intl.NumberFormat('en-US'),
    fromdate_menu: false,
    fromdate: null,
    maximumItem: 4,
    todate_menu: false,
    todate: null,
    page: 1,
    pageCount: 0,
    itemsPerPage: -1,
    search: '',
    dialog: false,
    dialog2: false,
    mapFile: '',
       // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    codeSearchItems: {
      header: ['GRP_CODE'],     
      data: [{
        GRP_CODE:'',
      }],
    },
    columns: [
      {field: 'custome', width: 47, customSlot: true, checkShow : true, isShowSelect: (item) => { return item.SYSSTATUS != 'I' }, titleAlign: 'center',columnAlign:'center',type: 'selection', isFrozen:  true},
      {field: 'SRM_SNDR', width: 153, customSlot: true, className:"sender-col", columnAlign: 'left', isFrozen:  true},
      {field: 'SRM_RCVR', width: 169, customSlot: true, className:"receiver-col", columnAlign: 'left', isFrozen:  true},
      {field: 'SRM_MSG_ID', width: 118, customSlot: true, className:"message-col", columnAlign: 'left', isFrozen:  true},
      {field: 'SRM_PRCS_STS', width: 154, columnAlign: 'center', customSlot: true, isFrozen:  true},
      {field: 'layout', width: 93, className: "layout-col", customSlot: true, columnAlign: 'center', isResize: true, isFrozen:  true},
      {field: 'MAP_NAME', width: 170, className: "map-name-col", customSlot: true, columnAlign: 'left'},
      {field: 'FFL_FILE_NAME', width: 157, columnAlign: 'left'},
      {field: 'MPD_FILE_NAME', width: 200, columnAlign: 'left'},
      {field: 'ATF_FILE_NAME', width: 252, customSlot: true, columnAlign: 'left'},
      {field: 'SRM_COMM_TP', width: 144, customSlot: true , columnAlign: 'center'},
      {field: 'SRM_CRE_DT', width: 174, className: "create-date-col", columnAlign: 'center'},
      {field: 'SRM_UPD_DT', width: 168, className: "update-date-col", columnAlign: 'center' },
      {field: 'SRM_CRE_USR', width: 144, className: "create-user-col", columnAlign: 'center'},
      {field: 'SRM_UPD_USR', width: 158, className: "update-user-col", columnAlign: 'center' },
    ],
    titleRows: [[
      {fields: ['custome'], title: '', titleAlign: 'center'},
      {fields: ['SRM_SNDR'], title: 'Sender', titleAlign: 'center', newprop: 'newprop'},
      {fields: ['SRM_RCVR'], title: 'Receiver', titleAlign: 'center'},
      {fields: ['SRM_MSG_ID'], title: 'Message', titleAlign: 'center'},
      {fields: ['SRM_PRCS_STS'], title: 'Status', titleAlign: 'center'},
      {fields: ['layout'], title: 'Layout', titleAlign: 'center'},
      {fields: ['MAP_NAME'], title: 'Map', titleAlign: 'center'},
      {fields: ['FFL_FILE_NAME'], title: 'FlatFile Layout', titleAlign: 'center'},
      {fields: ['MPD_FILE_NAME'], title: 'Mapping Definition', titleAlign: 'center'},
      {fields: ['ATF_FILE_NAME'], title: 'Reference Files', titleAlign: 'center'},
      {fields: ['SRM_COMM_TP'], title: 'Communication', titleAlign: 'center'},
      {fields: ['SRM_CRE_DT'], title: 'Create Date', titleAlign: 'center'},
      {fields: ['SRM_UPD_DT'], title: 'Update Date', titleAlign: 'center'},
      {fields: ['SRM_CRE_USR'], title: 'Create User', titleAlign: 'center'},
      {fields: ['SRM_UPD_USR'], title: 'Update User', titleAlign: 'center'}
      ]
    ],
    SummaryList: {
      headers: [
        {text: '', value: 'checkbox'},
        {text: 'Sender', value: 'SRM_SNDR'},
        {text: 'Receiver', value: 'SRM_RCVR'},
        {text: 'Message', value: 'SRM_MSG_ID'},
        {text: 'Status', value: 'SRM_PRCS_STS', width: 200},
        {text: 'Layout', value: 'layout'},
        {text: 'Map', value: 'MAP_NAME'},
        {text: 'FlatFile Layout', value: 'FFL_FILE_NAME'},
        {text: 'Mapping Definition', value: 'MPD_FILE_NAME'},
        {text: 'Reference Files', value: 'ATF_FILE_NAME'},
        {text: 'Communication', value: 'SRM_COMM_TP'},
        {text: 'Create Date', value: 'SRM_CRE_DT', width: 200},
        {text: 'Update Date', value: 'SRM_UPD_DT', width: 200},
        {text: 'Create User', value: 'SRM_CRE_USR'},
        {text: 'Update User', value: 'SRM_UPD_USR'}
      ],
      selected: [],
    },
    SummDataList: {
      headers: [
        { text: 'File ID', value: 'MST_PRCS_NO' },
        { text: 'Sender', value: 'MST_MSG_SNDR' },
        { text: 'Receiver', value: 'MST_MSG_RCVR' },
        { text: 'Message', value: 'MST_MSG_ID' },
        { text: 'Version', value: 'MST_MSG_VER' },
        { text: 'Upload File', value: 'MST_INPT_FIL_NM' },
        { text: 'Upload Date', value: 'MST_UPD_DT' },
        { text: 'Transaction Date', value: 'MST_TRAN_DT' }
      ]
    },
    masterSearchItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT', 'PRCS_STS'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: ''
      }],
      init: {
        DAT_TYPE: 'UPDT',
        FR_DAT: beforeOneMonth(),
        TO_DAT: new Date().toISOString().substr(0, 10),
        FR_DAT_PREV: beforeOneMonth(),
        TO_DAT_PREV: new Date().toISOString().substr(0, 10),
        FR_DAT_ERROR: [],
        TO_DAT_ERROR: []
      }
    },
    subGridSearchItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: ''
      }]
    },
    openLayoutViewItems: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT','MAP_NAME','FFL_FILE_NAME','MAP_CONV_TP'],
      data: [{
        CUST_ID: '',
        STR_SNDR: '',
        STR_RCVR: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        MSG_CNT: '',
        FFL_FILE_NAME: '',
        MAP_NAME:'',
        MAP_CONV_TP: ''
      }]
    },
    openMergeViewItems: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT','PRCS_STS','LAY_PRCS_NO','ALIAS'],
      data: [],
    },
    copyToMatchingItems: {      
      header: ['ADMIN_YN','CUST_ID','LAY_PRCS_NO'],
      data: [{
        ADMIN_YN: '',
        CUST_ID: '',
        LAY_PRCS_NO: ''
      }]         
    },
    copyToMatchingItems2: {      
      header: ['ADMIN_YN','SRM_PRCS_NO'],
      data: [{
        ADMIN_YN: '',        
        SRM_PRCS_NO: ''
      }]         
    },
    saveItemsHeader: {
      header: ['SYSSTATUS','SRM_PRCS_NO','LAY_PRCS_NO','MAP_PRCS_NO','CUST_ID','SRM_PRCS_STS','SRM_SNDR','SRM_RCVR','SRM_MSG_ID', 'SRM_COMM_TP'],
      data: [{
        SYSSTATUS: '',
        SRM_PRCS_NO: '',
        LAY_PRCS_NO: '',
        MAP_PRCS_NO: '',
        CUST_ID: '',
        SRM_PRCS_STS: '',
        SRM_SNDR: '',
        SRM_RCVR: '',
        SRM_MSG_ID: '',
        SRM_COMM_TP: ''
      }]
    },
    downloadReferenceHeader: {
      header: ['SRM_PRCS_NO'],
      data: [
        {SRM_PRCS_NO: ''}
      ]
    },
    searchBy: 'all',
    searchByItems: [
      { text: 'All', value: 'all' },
      { text: 'Sender', value: 'SRM_SNDR', },
      { text: 'Receiver', value: 'SRM_RCVR' },
      { text: 'Message', value: 'SRM_MSG_ID' },
      { text: 'Create Date', value: 'SRM_CRE_DT' },
      { text: 'Update Date', value: 'SRM_UPD_DT' }
    ],
    messageFormatMap : {
      'E' : 'EDIFACT',
      'X' : 'ANSI X12'
    },
    selectedMasterItem : {},
    arrLayoutDialog: [],
    dialogs: [],
    senders: [],
        // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    dateTypes:[
      // {value: 'UPDT', text: 'Update Date'},
      // {value: 'CRDT', text: 'Create Date'},
    ],
    dialogId: 1,
    styles: [
      { name: 'dialog-1'},
      { name: 'dialog-2'},
      { name: 'dialog-3'}
    ],
    style: null,
    selected: null,
    dialogWidth: 400,
    icons: {
      gitHub: ghIcon,
      browser: browserIcon,
      download: downloadIcon,
      dialog: dialogIcon
    },
    app: process.env.APP,
    selectMasterRows: [],
    layoutViewArr: [],
    uploadFileViewArr: [],
    statusStatArr: [
      { value: 'AD', name: 'Added', count: 0, color: '', class: 'srm-added-status' },
      { value: 'SL', name: 'Initialized', count: 0, color: '', class: 'srm-init-status' },
      { value: 'DV',  name: 'Developing', count: 0, color: '', class: 'srm-developing-status' },
      { value: 'TE',  name: 'Testing', count: 0, color: '', class: 'srm-testing-status' },
      { value: 'CO',  name: 'Completed', count: 0, color: '', class: 'srm-completed-status' },
      { value: 'OL',  name: 'On Live', count: 0, color: '', class: 'srm-onlive-status' },
    ],
     // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    communicationArr: [
      // {text:'FTP', value:'FT'},
      // {text:'sFTP', value:'SF'},
      // {text:'FTPS', value:'FS'},
      // {text:'SMTP', value:'SM'},
      // {text:'IMAP', value:'IM'},
      // {text:'POP3', value:'PO'},
      // {text:'MQ', value:'MQ'}
    ],
    srmStatusArr: [
      // {text:'Initialized', value:'SL'},
      // {text:'Developing', value:'DV'},
      // {text:'Testing', value:'TE'},
      // {text:'Completed', value:'CO'},
      // {text:'On Live', value:'OL'}
    ],
    srmStatusSearchArr: [
      {text:'Select All', value : ''},
      // {text:'Added', value:'AD'},
      // {text:'Initialized', value:'SL'},
      // {text:'Developing', value:'DV'},
      // {text:'Testing', value:'TE'},
      // {text:'Completed', value:'CO'},
      // {text:'On Live', value:'OL'}
    ],
  }),
  watch: {
    mainGrid: function(data) {
      this.resetStatusStatArr();
      //this.queryList();
      for(let i = 0; i < data.length; i++) {
        this.increaseStatusStat(data[i].SRM_PRCS_STS);
      }
    }
  },
  methods: {
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    getStatus(){
      this.codeSearchItems.data[0].GRP_CODE ="A05";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => { 
          console.log("--------- Finished to process Status List ----------"); 
          for(let i=0;i< this.codeList.length;i++){
          let codeObj= {};
          codeObj.text= this.codeList[i].CM_CODE_NAME;
          codeObj.value= this.codeList[i].CM_CODE_ID;
          this.srmStatusSearchArr.push(codeObj);
          this.srmStatusArr.push(codeObj);
          }
        });
    },
    getDateType(){
      this.codeSearchItems.data[0].GRP_CODE ="A06";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => { 
          console.log("--------- Finished to process Date Type ----------"); 
          for(let i=0;i< this.codeList.length;i++){
          let codeObj= {};
          codeObj.text= this.codeList[i].CM_CODE_NAME;
          codeObj.value= this.codeList[i].CM_CODE_ID+'T';
          this.dateTypes.push(codeObj);
          }
        });
    },
    getCommunication(){
      this.codeSearchItems.data[0].GRP_CODE ="A07";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => { 
          console.log("--------- Finished to process Communication ----------"); 
          for(let i=0;i< this.codeList.length;i++){
          let codeObj= {};
          codeObj.text= this.codeList[i].CM_CODE_NAME;
          codeObj.value= this.codeList[i].CM_CODE_ID;
          this.communicationArr.push(codeObj);
          }
        });
    },
    queryList () {
      //[2020-04-15] apply by CLV: Apply srmlist/queryList api
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        console.log("--------- getSummaryList ----------");
        console.log("before fromdate(" + this.masterSearchItems.init.FR_DAT + ")");
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(this.masterSearchItems.init.FR_DAT);
        console.log("after fromdate(" + this.masterSearchItems.data[0].FR_DAT + ")");
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(this.masterSearchItems.init.TO_DAT);
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        Store.dispatch("srmlist/queryList", this.masterSearchItems).then(() => {
          console.log("--------- Finished to process ----------");
          this.selectMasterRows = [];
          //console.log(JSON.stringify(this.masterItems));
        });

        this.quickSearch = "";
      } else {
        this.$refs.SearchCondition.dialog = true;
      }
    },
    viewSummDataList (event, selItem) {
      this.selectedMasterItem = selItem;
      console.log("--------- viewSummDataList ----------");
      this.subGridSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      this.subGridSearchItems.data[0].MSG_SNDR  = selItem.MST_MSG_SNDR;
      this.subGridSearchItems.data[0].MSG_RCVR  = selItem.MST_MSG_RCVR;
      this.subGridSearchItems.data[0].MSG_ID  = selItem.MST_MSG_ID;
      this.subGridSearchItems.data[0].MSG_VER  = selItem.MST_MSG_VER;
      this.subGridSearchItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.subGridSearchItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.subGridSearchItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;

      Store.dispatch("analysis/getSummaryDataList", this.subGridSearchItems).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    viewFile (item) {

      let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
      if (index != null) {
        return;
      }

      this.params =  {
        edifile : item.MST_INPT_FIL_NM,
        bizfile : item.MST_BIZ_FIL_NM,
        ROWID : item.ROWID.toString()
      };

      this.uploadFileViewArr.push(item);
      Store.commit('analysis/SET_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));

      var w = window.open(`/edimanager/UploadFileView/${item.ROWID}`, '_blank', "width=1000,height=750,left=100,top=30");
      w.params = this.params;
      w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      w.closePopup = () => {
        let index = w.parent.findIndexItem(item, w.parent.uploadFileViewArr, 'ROWID');
        w.parent.uploadFileViewArr.splice(index, 1);
        Store.commit('analysis/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, w.parent.params));
        w.close();
      }
      if (typeof window.fileViewOpenWindow == 'undefined') {
        window.fileViewOpenWindow = {[item.ROWID.toString()] : w.closePopup};
      } else {
        window.fileViewOpenWindow[item.ROWID.toString()] = w.closePopup;
      }
      w.onbeforeunload = w.closePopup;

    },

    formatNumber(num) {
      return this.numberFormatter.format(num);
    },
    openLayoutView(item) {
      let index = this.findIndexItem(item, this.layoutViewArr, 'ROWID');
      if (index != null) {
        window.layoutFocus[item.ROWID.toString()]();
        return;
      }

      this.openLayoutViewItems.data[0].CUST_ID  = $cookies.get('comp-id');
      this.openLayoutViewItems.data[0].MSG_STD  = item.LAY_MSG_STD;
      this.openLayoutViewItems.data[0].MSG_ID  = item.LAY_MSG_ID;
      this.openLayoutViewItems.data[0].MAP_NAME  = item.MAP_NAME;
      this.openLayoutViewItems.data[0].MAP_CONV_TP  = item.MAP_CONV_TP;
      this.openLayoutViewItems.data[0].FFL_FILE_NAME  = item.FFL_FILE_NAME;
      this.openLayoutViewItems.data[0].FFL_FRMT_TP  = item.FFL_FRMT_TP;
      this.openLayoutViewItems.data[0].MSG_VER  = item.LAY_MSG_VER;
      this.openLayoutViewItems.data[0].STR_SNDR =  item.SRM_SNDR;
      this.openLayoutViewItems.data[0].STR_RCVR =  item.SRM_RCVR;
      this.openLayoutViewItems.data[0].MSG_CNT = item.ATF_FILE_CNT;
      this.openLayoutViewItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.openLayoutViewItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.openLayoutViewItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;
      this.openLayoutViewItems.data[0].PRCS_STS = item.SRM_PRCS_STS;
      this.openLayoutViewItems.data[0].LAY_PRCS_NO = item.LAY_PRCS_NO;
      this.openLayoutViewItems.data[0].SRM_PRCS_NO = item.SRM_PRCS_NO;
      this.openLayoutViewItems.data[0].ALIAS = '';
      this.openLayoutViewItems.data[0].ROWID = item.ROWID;

      this.params = this.openLayoutViewItems.data[0];

      this.layoutViewArr.push(item);
      Store.commit('layout/SET_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));

      var w = window.open(`/edimanager/EdiAnalyzedView_SRM/${item.ROWID}`, '_blank', "width=1550,height=750,left=100,top=30");
      w.mode = "MergeView";
      w.params = this.params;
      w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      w.closePopup = () => {
        let index = w.parent.findIndexItem(item, w.parent.layoutViewArr, 'ROWID');
        w.parent.layoutViewArr.splice(index, 1);
        Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, w.parent.params));
        w.close();
      }
      w.focusPopup = () => {
        w.focus();
      }
      if (typeof window.layoutOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.layoutOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocus = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.layoutOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocus[item.ROWID.toString()] = w.focusPopup;
      }
      w.onbeforeunload = w.closePopup;
    },

    openMergeView() {
      if (this.selectMasterRows.length < 2) {
        this.$refs.mergeCompareInfoDialog.dialog = true;
      } else {
        this.openMergeViewItems.data = [];
        // add by April for test. plz modify according to concept.
        let mergeItem = this.selectMasterRows[0];
        console.log(this.selectMasterRows);
        let total_cnt = 0;
        for(var i = 0; i <this.selectMasterRows.length; i++){
          this.openMergeViewItems.data[i] = {
            CUST_ID: `${this.$cookies.get('comp-id')}`,
            STR_SNDR: `${this.selectMasterRows[i].MST_MSG_SNDR}`,
            STR_RCVR: `${this.selectMasterRows[i].MST_MSG_RCVR}`,
            MSG_STD: `${this.selectMasterRows[i].MST_MSG_STD}`,
            MSG_ID: `${this.selectMasterRows[i].MST_MSG_ID}`,
            MSG_VER: `${this.selectMasterRows[i].MST_MSG_VER}`,
            DAT_TYPE: `${this.masterSearchItems.data[0].DAT_TYPE}`,
            FR_DAT: `${this.masterSearchItems.data[0].FR_DAT}`,
            TO_DAT: `${this.masterSearchItems.data[0].TO_DAT}`,
            MSG_CNT: '',
            PRCS_STS: '',
            LAY_PRCS_NO: '',
            ALIAS: `ALIAS_${this.selectMasterRows[i].ROWID}`
          };
          total_cnt = total_cnt + this.selectMasterRows[i].MSG_CNT;
        }
        this.params = this.openMergeViewItems.data;
        console.log(this.params);

        //[2020-03-26] apply by CLV: Change to open new window
        var w = window.open(`/edimanager/AnalysisCompareMerge`, '_blank', "width=1825,height=700,left=100,top=100");

        ///////////////////////

        // let type = "MergeCompare";
        // let id = `${type}_${this.dialogId}`;
        // let indexArrDialog = this.findDialog(id);
        // if (indexArrDialog != null) {
        //   return;
        // }
        // this.newDialog({id, type}, type) - 1;
        //[2020-26-06] Change open new dialog by CLV
        w.params = this.params;
        w.mode = 'MergeView';
        w.pageTitle = "EDI Analyzed Merge View"
        w.total_cnt = total_cnt;
        console.log("Test-Change open new dialog by CLV");
        console.log(w.params);
        w.closePopup = () => {
          w.close();
        }

        if (typeof window.mergeOpenWindow == 'undefined') {
          window.mergeOpenWindow = {'close' : w.closePopup};
        } else {
          window.mergeOpenWindow['close'] = w.closePopup;
        }

        w.onbeforeunload = w.closePopup;
      }
    },
    copyToMatching() {
      // add by April
      // Plz set all of the rows what selected from first grid
      this.copyToMatchingItems.data = [];
      for(let i = 0; i < this.selectMasterRows.length; i++) {
        let item = this.selectMasterRows[i];
        this.copyToMatchingItems.data.push({
          CUST_ID : $cookies.get('comp-id'),
          MSG_SNDR : item.MST_MSG_SNDR,
          MSG_RCVR : item.MST_MSG_RCVR,
          MSG_ID : item.MST_MSG_ID,
          MSG_VER : item.MST_MSG_VER,
          DT_TYPE : this.masterSearchItems.data[0].DAT_TYPE,
          FR_DAT : this.masterSearchItems.data[0].FR_DAT,
          TO_DAT : this.masterSearchItems.data[0].TO_DAT
        })
      }

      Store.dispatch("analysis/copyToMatching", this.copyToMatchingItems).then(() => {
        console.log("--------- Finished to process ----------");
      });

    },
    copyToRepository() {      
      // add by April
      // Plz set all of the rows what selected from first grid      
      this.copyToMatchingItems2.data = [];
      this.copyToMatchingItems2.data.push({
          ADMIN_YN : 'Y',
          SRM_PRCS_NO : 'SRM0001757'
        })   ;

      this.copyToMatchingItems2.data.push({
          ADMIN_YN : 'Y',
          SRM_PRCS_NO : 'SRM0001758'
        })   ;        
      this.copyToMatchingItems2.data.push({
          ADMIN_YN : 'Y',
          SRM_PRCS_NO : 'SRM0001759'
        })   ;        
      this.copyToMatchingItems2.data.push({
          ADMIN_YN : 'Y',
          SRM_PRCS_NO : 'SRM0001760'
        })   ;       

      
      Store.dispatch("repository/copyToRepository", this.copyToMatchingItems2).then(() => {
        console.log("--------- Finished to process ----------");    
      });

    },
    saveRepository() {      
      // add by April
      // Plz set all of the rows what selected from first grid      
      this.copyToMatchingItems.data = [];
      this.copyToMatchingItems.data.push({
          ADMIN_YN : 'Y',
          CUST_ID : 'cyberlogitec.com',
          LAY_PRCS_NO : 'L000000548'
        })   ;

      this.copyToMatchingItems.data.push({
          ADMIN_YN : 'Y',
          CUST_ID : 'cyberlogitec.com',
          LAY_PRCS_NO : 'L000000549'
        })   ;
        
      this.copyToMatchingItems.data.push({
          ADMIN_YN : 'Y',
          CUST_ID : 'cyberlogitec.com',
          LAY_PRCS_NO : 'L000000550'
        })   ;
        
      this.copyToMatchingItems.data.push({
          ADMIN_YN : 'Y',
          CUST_ID : 'cyberlogitec.com',
          LAY_PRCS_NO : 'L000000551'
        })   ;        
      
      Store.dispatch("repository/saveRepository", this.copyToMatchingItems).then(() => {
        console.log("--------- Finished to process ----------");    
      });

    },    
    saveItems() {
      this.saveItemsHeader['data'] = [];
      for(let i = 0; i < this.mainGrid.length; i++) {
        let item = this.mainGrid[i];

        if (typeof item.SYSSTATUS == 'undefined' || item.SYSSTATUS == '') {
          continue;
        }
        if (item.SRM_SNDR.trim() == '' || item.SRM_RCVR.trim() == '' || item.SRM_MSG_ID.trim() == '') {
          this.$refs.addNewRowEmptyDialog.dialog = true;
          return;
        }

        if (this.isDuplicateSRMItem(item)) {
          this.$refs.addNewRowDuplicateDialog.dialog = true;
          return;
        }

        this.saveItemsHeader.data.push(
          {
            SYSSTATUS: item.SYSSTATUS,
            SRM_PRCS_NO: item.SYSSTATUS == 'I' ? '' : item.SRM_PRCS_NO,
            LAY_PRCS_NO: item.LAY_PRCS_NO,
            MAP_PRCS_NO: item.MAP_PRCS_NO,
            CUST_ID: $cookies.get('comp-id'),
            SRM_PRCS_STS: item.SRM_PRCS_STS,
            SRM_SNDR: item.SRM_SNDR,
            SRM_RCVR: item.SRM_RCVR,
            SRM_MSG_ID: item.SRM_MSG_ID,
            SRM_COMM_TP: item.SRM_COMM_TP
          }
        )
      }

      Store.dispatch("srmlist/saveSRMList", this.saveItemsHeader).then(() => {
        console.log("--------- Finished to process ----------");
        $('.srm-list-table .v-scrollbar-wrap').scrollTop(0);
        this.queryList();
      });
    },

    generateExcelFile() {
      let self = this;
      const excel = require('node-excel-export');

      // You can define styles as json object
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: 'FF496D94'
            }
          },
          font: {
            color: {
              rgb: 'FFFFFFFF'
            },
            sz: 14,
          }
        }
      };

      //Here you specify the export structure
      const specification = {
        SRM_SNDR: { // <- the key should match the actual data key
          displayName: 'Sender', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_RCVR: { // <- the key should match the actual data key
          displayName: 'Receiver', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_MSG_ID: { // <- the key should match the actual data key
          displayName: 'Message', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_PRCS_STS: { // <- the key should match the actual data key
          displayName: 'Status', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          cellFormat: function(value, row) { // <- Renderer function, you can access also any row.property
            let item = self.srmStatusArr.find((item) => { return item.value == value})
            return item ? item.text : '';
          },
          width: 120 // <- width in pixels
        },
        MAP_NAME: { // <- the key should match the actual data key
          displayName: 'Map', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        FFL_FILE_NAME: { // <- the key should match the actual data key
          displayName: 'FlatFile Layout', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        MPD_FILE_NAME: { // <- the key should match the actual data key
          displayName: 'Mapping Definition', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        ATF_FILE_NAME: { // <- the key should match the actual data key
          displayName: 'Reference Files', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_COMM_TP: { // <- the key should match the actual data key
          displayName: 'Communication', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          cellFormat: function(value, row) { // <- Renderer function, you can access also any row.property
            let item = self.communicationArr.find((item) => { return item.value == value})
            return item ? item.text : '';
          },
          width: 120 // <- width in pixels
        },
        SRM_CRE_DT: { // <- the key should match the actual data key
          displayName: 'Create Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_UPD_DT: { // <- the key should match the actual data key
          displayName: 'Update Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_CRE_USR: { // <- the key should match the actual data key
          displayName: 'Create User', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_UPD_USR: { // <- the key should match the actual data key
          displayName: 'Update User', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },

      }

      // Create the excel report.
      // This function will return Buffer
      const report = excel.buildExport(
        [ // <- Notice that this is an array. Pass multiple sheets to create multi sheet report
          {
            name: 'Report', // <- Specify sheet name (optional)
            heading: [], // <- Raw heading array (optional)
            merges: [], // <- Merge cell ranges
            specification: specification, // <- Report specification
            data: this.mainGrid // <-- Report data
          }
        ]
      );

      var data = new Blob([report.buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      var url = window.URL.createObjectURL(data);
      var a = document.createElement("a");
        a.href = url;
        a.download = 'SRMList.xlsx';
        document.body.appendChild(a);
        a.click();
    },

    isDuplicateSRMItem(item) {
      for (let i = 0; i < this.mainGrid.length; i++) {
        let srmitem = this.mainGrid[i];
        if (item.ROWID == srmitem.ROWID) {
          continue;
        }
        if (item.SRM_SNDR == srmitem.SRM_SNDR && item.SRM_RCVR == srmitem.SRM_RCVR && item.SRM_MSG_ID == srmitem.SRM_MSG_ID) {
          return true;
        }
      }
      return false;
    },

    resetStatusStatArr() {
      for(let i = 0; i < this.statusStatArr.length; i++) {
        let stat = this.statusStatArr[i];
        stat.count = 0;
      }
    },

    increaseStatusStat(value) {
      for(let i = 0; i < this.statusStatArr.length; i++) {
        let stat = this.statusStatArr[i];
        if (stat.value == value) {
          stat.count += 1;
        }
      }
    },

    onFilterAnalysis(str) {
      Store.commit('analysis/SET_STORE_ANALYSIS_FILTER', {filter : this.searchBy, str : this.search});
      let datarows = this.mainGridSource;
      let filterBy = {filter : this.searchBy, str : this.search};
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      Store.commit('srmlist/mainGridFilter', listResult);
    },

    changeFromDate(str) {
      if (!this.checkPeriod()) {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT_PREV;
        this.$refs.SearchCondition.dialog = true;
      } else {
        this.masterSearchItems.init.FR_DAT_PREV = str;
      }
    },

    changeToDate(str) {
      if (!this.checkPeriod()) {
        this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.TO_DAT_PREV;
        this.$refs.SearchCondition.dialog = true;
      } else {
        this.masterSearchItems.init.TO_DAT_PREV = str;
      }
    },

    checkPeriod() {
      let fromDate = new Date(this.masterSearchItems.init.FR_DAT);
      let toDate = new Date(this.masterSearchItems.init.TO_DAT);
      let maxDate = new Date(fromDate);
      maxDate.setMonth(maxDate.getMonth() + 6);
      if (toDate.getTime() < fromDate.getTime() || toDate.getTime() > maxDate.getTime() ) {
        return false;
      }
      return true;
    },

    selectAllChange(value) {
      let maxItem = this.maximumItem;
      let checkFlg = true;
      let selectAllItems = [];
      if(value && maxItem >= this.masterItems.length ){
        for (let i = 0; i < this.masterItems.length; i++) {
          let item = this.masterItems[i];
          if (item.MST_MSG_ID != this.masterItems[0].MST_MSG_ID) {
            checkFlg = false;
            this.$refs.warningDialog.dialog = true;
            break;
          }
        }
        if(checkFlg){
          for (let i = 0; i < this.masterItems.length; i++) {
            let item = this.masterItems[i];
            item.checked = value;
            selectAllItems.push(item);
          }
          this.selectMasterRows = selectAllItems;
        }
      }else if(value){
        this.$refs.mergeCompareInfoDialog.dialog = true;
      }else{
        for (let i = 0; i < this.masterItems.length; i++) {
          let item = this.masterItems[i];
          item.checked = false;
        }
        this.selectMasterRows = [];
      }
    },
    checkMessageType(item){
      if(this.selectMasterRows[0].MST_MSG_ID != item.MST_MSG_ID){
        this.$refs.warningDialog.dialog = true;
        return false
      }
      this.selectMasterRows.push(item);
      return true
    },
    srmStatusClass(item) {
      if(typeof item.SRM_PRCS_STS == 'string') {
        return `srm-${item.SRM_PRCS_STS.toLowerCase()}-select-box-status`;
      }
    },

    /*
    Date: [2020/03/31] Apply by CLV: Open alerts when select items(rows).
    Content: Logic biz: max row selected is up by customer.
    */
    selectItemChange(event, item) {
      let maxItem = this.maximumItem;
      let checked = item.checked;
      if (checked == true) {
        if (0 < this.selectMasterRows.length && maxItem > this.selectMasterRows.length) {
          item.checked = this.checkMessageType(item);
        }
        else if ((maxItem - 1) < this.selectMasterRows.length) {
          item.checked = false;
          this.$refs.mergeCompareInfoDialog.dialog = true;
        }
        else if (this.selectMasterRows.length == 0){
          this.selectMasterRows.push(item);
        }
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'ROWID');
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
    },
    findIndexItem(item, arr, col) {
      let prop = (typeof col == 'undefined') ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop]
      })
      return (index > -1) ? index : null
    },

    openDialog () {
      let type = "ediUploadFile";
      let item = {
        ROWID : 0
      }
      let indexArrDialog = this.findDialog("ediUploadFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
     openMapListDialog (selectItem) {
      let type = "mapList";
      let item = {
        ROWID : 0,
        item: selectItem
      }
      let indexArrDialog = this.findDialog("mapList_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
     openAddReferenceFileDialog (rowItem) {
      let type = "addReferenceFile";
      let item = {
        ROWID : 0,
        item: rowItem
      }
      let indexArrDialog = this.findDialog("addReferenceFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    downloadAttachFile(srmitem) {
      this.downloadReferenceHeader.data[0].SRM_PRCS_NO = srmitem.SRM_PRCS_NO;
      Store.dispatch("srmlist/downloadAllReferenceFiles", this.downloadReferenceHeader ).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    openReferenceList (selectedItem) {
      let type = "refenrenceFilesList";
      let item = {
        ROWID : 0,
        item: selectedItem
      }
      let indexArrDialog = this.findDialog("refenrenceFilesList_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    loadMapList(item) {
      this.mapFile = item.MAP_NAME;
    },

    addRowSRMList() {
      let newRow = {
        'ROWID': this.getMaxRowID(),
        'SRM_SNDR' : '',
        'SRM_RCVR' : '',
        'SRM_MSG_ID' : '',
        'SRM_PRCS_STS' : 'ADDED',
        'layout' : '',
        'MAP_NAME' : '',
        'FFL_FILE_NAME' : '',
        'MPD_FILE_NAME' : '',
        'ATF_FILE_NAME' : '',
        'SRM_COMM_TP' : '',
        'SRM_CRE_DT' : '',
        'SRM_UPD_DT' : '',
        'SRM_CRE_USR' : '',
        'SRM_UPD_USR' : '',
        'SYSSTATUS': 'I'
      }

      this.mainGrid.push(newRow);
      setTimeout(()=> {
        $('html').scrollTop($('html').height());
        $('.srm-list-table .v-scrollbar-wrap').scrollTop(this.mainGrid.length * 40);
      }, 300);
    },

    deleteSRMRowItem(item) {
      let index = this.findIndexItem(item, this.mainGrid, 'ROWID');
      if (index != null) {
        //this.$nextTick(() => {
          this.mainGrid.splice(index, 1);
        //});
      }
    },

    setRowClassName(index, item) {
      if(item['hidden']) {
        return 'd-none';
      }
    },

    selectStatus(status) {
      for (let i = 0; i < this.mainGrid.length; i++) {
        let srmItem = this.mainGrid[i];
        if (srmItem['SRM_PRCS_STS'] != status.value) {
          srmItem.hidden = true;
        } else {
          srmItem.hidden = false;
        }
      }
      this.$refs.srm_list_table.$forceUpdate();
      Store.commit('srmlist/mainGridFilter', this.mainGrid);
    },

    getMaxRowID() {
      let maxRowID = 1;
      for (let i = 0; i < this.mainGrid.length; i++) {
        if (maxRowID <= this.mainGrid[i].ROWID) {
          maxRowID = this.mainGrid[i].ROWID + 1;
        }
      }
      return maxRowID;
    },

    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },

    removeDialog (dialog) {
      let id = dialog.id
      let index = this.findDialog(id)
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1)
      if (this.selected && this.selected.id === id) this.selected = null
    },

    findDialog (id, dialogs) {
      if (!dialogs) dialogs = this.dialogs
      let index = dialogs.findIndex((val) => {
        return val.id === id
      })
      return (index > -1) ? index : null
    },
    generateDialog (item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId, item: item.item};
      return { id, name, type, options }
    },
    dialogDragEnd (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },
    selectDialog (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },
    updatedMap(mapItems){
      let {item, selectItem} = mapItems;
      selectItem.MAP_NAME= item.MAP_NAME;
      selectItem.FFL_FILE_NAME = item.FFL_FILE_NAME;
      selectItem.MPD_FILE_NAME = item.MPD_FILE_NAME;
      selectItem.MAP_PRCS_NO = item.MAP_PRCS_NO;
      selectItem.SYSSTATUS = 'U';

        //Store.dispatch('srmlist/updateMap', {query : mapItems});
    },
     updatedReferenceFiles(referenceFilesItems){

      let {item, selectItem} = referenceFilesItems;
      this.$refs.addReferenceFile[0].addreferenceFileRow(referenceFilesItems);
    }


  },
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23

  created () {
    this.queryList ();
    this.getStatus();
    this.getDateType();
    this.getCommunication();
  },
  mounted () {
    let a = $('.v-content__wrap');
    this.$nextTick(() => {
      console.log(this.headers);
    })
  }
}
</script>


<style>
  .tab-text {
    padding-left: 5px !important;
    justify-content: left !important;
  }
  .v-tabs.theme--dark > .v-item-group {
    background-color: #424242 !important;
  }
  .v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
    background-color: #424242 !important;
  }
  div.page-info-text {
    padding-top: 20px;
  }

  div.table-pagination ul.v-pagination {
    justify-content: inherit;
  }
  div.table-pagination ul li:not(:first-child):not(:last-child) {
    display : none;
  }
  div.table-pagination ul li button {
    width : 70px;
    height : 40px;
    margin-top : 0px;
    background-color : #3B3E49 !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color : white !important;
  }
  div.table-pagination ul li:first-child i::before {
    content : "\f0d9";
    font-size : 14px;
  }
  div.table-pagination ul li:first-child i::after {
    content : " Prev";
    font-size : 14px;
    font-family: monospace;
    white-space: pre;
  }
  div.table-pagination ul li:last-child i::before {
    content : "Next ";
    font-size : 14px;
    font-family: monospace;
    white-space: pre;
  }
  div.table-pagination ul li:last-child i::after {
    content : "\f0da";
    font-size : 14px;
  }
  /* .custom-table-300 .v-data-table__wrapper{
    overflow-y: auto ;
    min-height: 300px ;
    max-height: 301px ;
  }
  .custom-table-500 .v-data-table__wrapper{
    overflow-y: auto ;
    min-height: 500px ;
    max-height: 501px ;
  } */
  .from-date-picker .v-text-field__details {
    display: none;
  }
  .to-date-picker .v-text-field__details {
    display: none;
  }

  .srm-total-status-section {
    display: inline-block;
    margin-right: 20px;
  }

  .status-stat-section {
    font-size: 11px;
    font-weight: bold;
  }
  .srm-added-status {
    background: #FFFFFF;
    border: 0.5px solid #7D838D;
  }

  .srm-status-stat {
    display: inline-block;
    cursor: pointer;
  }
  /* .srm-status-name {
    display: inline-block;
    text-align: center;
    width: 70px;
  } */
  .srm-status-count {
    font-size: 16px;
    line-height: 21px;
    color: #0082BA;
    margin-right: 15px;
  }
  .srm-init-status {
    background: #E0F6FF;
    border: 0.5px solid #7D838D;
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;
    color: #606268;
    margin-right: 10px;
  }
  .srm-developing-status {
    background: #FFFCE0;
    border: 0.5px solid #7D838D;
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;
    color: #606268;
    margin-right: 10px;
  }
  .srm-testing-status {
    background: #FFFCE0;
    border: 0.5px solid #7D838D;
    font-size: 11px;
    line-height: 22px;
    font-weight: 600;
    color: #606268;
    margin-right: 10px;
  }
  .srm-completed-status {
    background: #E8FFE0;
    border: 0.5px solid #7D838D;
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;
    color: #606268;
    margin-right: 10px;
  }
  .srm-onlive-status {
    background: #FFE4E0;
    border: 0.5px solid #7D838D;
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;
    color: #606268;
    margin-right: 10px;
  }
  /* .srm-total-status-text {
    font-size: 16px;
    line-height: 21px;
    font-weight: 600;
    align-items: center;
    color: #18236D;
  }

  .theme--dark .srm-total-status-text {
    font-size: 16px;
    line-height: 21px;
    font-weight: 600;
    align-items: center;
    color: #bbbbbb;
  } */

  .srm-total-status {
    font-size: 16px;
    line-height: 21px;
    color: #0082BA;
    padding-left: 2px;
    padding-right: 2px;
  }
  /* .ref-file-icon {
    float: right;
    padding-top: 14px;
  } */
  /*.status-stat-section {}*/

  .flatfile-layout-list{
    width: 888px !important;
    height: 410px !important;
  }

  .compare-merge-table.srm-list-table .v-table-btable div.v-table-body-cell {
    font-size: 14px !important;
  }
  .srm-list-table{
    min-height: 0px !important;
  }

  .theme--dark .data-table-select-box.search-selectbox .v-input__control .v-input__slot .v-select__selections .v-select__selection {
    color: #bbbbbb !important;
  }

  .theme--dark .data-table-select-box.search-selectbox .v-input__control .v-input__slot .v-input__append-inner i {
    color: white !important;
  }
</style>